import React from 'react'

const Tips = ({text}) => (<p className='poppins-10px-300' style={{margin:"10px 0"}}>{text}</p>)

export default Tips
